var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('participant-details-component',{attrs:{"ui":'cultural_advisor',"routeToList":'employee-participants-list'}})}
var staticRenderFns = []

export { render, staticRenderFns }